/**
 * @desc 通过定义key获取已部署流程定义用户任务节点列表
 */
const URL = "/rantion-activiti";
import http, { updateResponse } from "@/http";
export type Response = defs.activiti.ResponseDto<Array<defs.activiti.BpmnUserTask>>;
export function request(
  params: API.activiti.bpmProc.getDeployProcDefUserTaskNodes.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/bpm/proc/deploy/def/userTaskNodes`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
